import {isObjectEmpty} from "../../../../../../../../helpers/tools";

const INITIAL_POPUP = {show: false, formName: '', title: '', variant: 'error', message: ''}

const INITIAL_STATE = {
    returnPatch: "",   // sessionStorage.getItem('project-current-return'),
    projectName: "",
    popup: INITIAL_POPUP,
    direction: {first_name: "", last_name: "", pk: null},
    directionsList: [],
    concertmaster: {},
    concertmastersList: [],
    cooperationWith: [],
    cooperationsWithList: [],
    solistes: [],
    solistesList: [],
    dressCode: "",
    projectProgram: "",
    projectComment: "",
    aboutPupitre: "",
}

const find_cooperationsWith = (pk, cooper) => {
    return cooper.some(el => el.pk === pk) ? pk : 0
}

const find_solistes = (pk, solistes) => {
    return solistes.some(el => el.pk === pk) ? pk : null
}

const techInfoReducer = (state, action) => {
    switch (action.type) {
        case "INITIAL_DATA":
            const dirList = action.directionsList.map(el => ({
                value: el.pk, label: el.cn__first_name+" "+el.cn__last_name,
                first_name: el.cn__first_name, last_name: el.cn__last_name
            }))
            const concert_master_list = action.concertmastersList.map(el => ({value: el.fullname, label: el.fullname, pk: el.pk}))
            const cooperation_list = action.cooperationsWithList.map(el => ({value: el.name, label: el.name, pk: el.pk}))
            const solistes_list = action.solistesList.map(el => ({
                value: el.pk, label: el.cn__first_name+" "+el.cn__last_name,
                first_name: el.cn__first_name, last_name: el.cn__last_name,
                comment: el.comment
            }))
            return {
                ...state,
                projectName: action.projectName,
                returnPatch: action.returnPatch,
                direction: action.direction,
                directionsList: dirList,
                concertmastersList: concert_master_list,
                concertmaster: action.concertmaster,
                cooperationWith: action.cooperationWith,
                cooperationsWithList: cooperation_list,
                solistes: action.solistes,
                solistesList: solistes_list,
                dressCode: action.dressCode,
                projectProgram: action.projectProgram,
                projectComment: action.projectComment,
                aboutPupitre: action.aboutPupitre,
            }

        case "CREATE_POPUP_DIRECTION":
            if (isObjectEmpty(state.direction)) {
                return {...state, popup: {
                        show: true,
                        formName: "direction",
                        title: 'popups.tech_info_add_people.conductor_title',
                        variant: 'editF',
                        message: 'popups.tech_info_add_people.option_txt',
                        leftBtn: "common.button.add",
                        rightBtn: "common.button.cancel",
                    }}
            } else return state

        case "CREATE_POPUP_COOPERATION":
            return {...state, popup: {
                    show: true,
                    formName: "cooperationWith",
                    title: 'popups.tech_info_add_people.add_coop_partner_title',
                    variant: 'editF',
                    message: 'popups.tech_info_add_people.option_txt',
                    leftBtn: "common.button.add",
                    rightBtn: "common.button.cancel",
            }}

        case "CREATE_POPUP_SOLIST":
            // popup dodawania solistes
            return {...state, popup: {
                    show: true,
                    formName: "solistes",
                    title: 'popups.tech_info_add_people.add_soloist_title',
                    variant: 'editF',
                    message: 'popups.tech_info_add_people.option_txt',
                    leftBtn: "common.button.add",
                    rightBtn: "common.button.cancel",
                }}

        case "SET_DIRECTION":
            return {...state,
                direction: {
                    first_name: action.dataset.first_name,
                    last_name: action.dataset.last_name,
                    pk: action.dataset.value
            }}

        case "REMOVE_DIRECTION":
            return {...state, direction: {}}

        case "SET_POPUP":
        case "SET_DRESS_CODE":
        case "SET_ABOUTPUPITRE":
        case "SET_PROJECT_PROGRAM":
        case "SET_PROJECT_COMMENT":
        case "DIRECTION_OPTIONS_FORM":
            return {...state, [action['key']]: action.dataset};

        case "SET_CONCERTMASTER":
            return {...state, concertmaster: {name: action.dataset.label, pk: action.dataset.pk}};

        case "SET_COOPERATION_WITH":
            const newData = [...state.cooperationWith, {name: action.dataset.value, pk: action.dataset.pk}];
            return {...state, cooperationWith: newData};

        case "SET_SOLIST":
            const newSolistesData = [
                ...state.solistes,
                {first_name: action.dataset.first_name, last_name: action.dataset.last_name,
                    comment: action.dataset.comment,
                    pk: action.dataset.value
                }
            ];
            return {...state, solistes: newSolistesData};

        case "REMOVE_COOPERATION_WITH":
            const cooperat_with_copy = structuredClone(state.cooperationWith);
            const cooperat_with = cooperat_with_copy.filter(elem => elem.pk !== action['pk']);
            return {...state, cooperationWith: cooperat_with};

        case "SET_COMMENT_SOLIST":
            const solistCopy = structuredClone(state.solistes);
            const solistItem = solistCopy.find(el => el.pk === action.pk)
            solistItem.comment = action.comment;
            return {...state, solistes: solistCopy};

        case "REMOVE_SOLIST":
            const newSolistsList = state.solistes.filter(solist => solist.pk !== action.pk);
            return {...state, solistes: newSolistsList};

        case "SAVE_TO_DB":
            return {...state, popup: {
                        show: true,
                        title: 'Save to db',
                        message: "Czy zapisać dane do bazy?",
                        formName: "globalSave",
                        variant: 'editF',
                        leftBtn: "common.button.save",
                        rightBtn: "common.button.cancel",
                    }}

        default:
            throw new Error('Unknown action: ' + action);
            return state
    }
}

export {techInfoReducer, INITIAL_STATE, INITIAL_POPUP, find_cooperationsWith, find_solistes}